import React, {useState} from "react"
import "./RescueDebug.css"

export default function RescueDebug(props) {

    const {rescue} = props
    const [open, setOpen] = useState(false)
    
    return <section id="debug">
        {!open && <button className="btn btn-sm btn-light" onClick={e => setOpen(true)}>JSON</button>}
        
        {open && <section className="white shadow">
            {rescue.dirty && <h1>Dirty</h1>}
            <pre>{JSON.stringify(rescue.rescue, null, 2)}</pre>
            <pre>{JSON.stringify(rescue.permissions, null, 2)}</pre>
        </section>}
    </section>
}
